import React from "react";

interface Props {
  base64?: string | null;
}

/**
 * 🖼️ QzTrayPreviewLogo
 *
 * Muestra el logo del ticket en formato Base64.
 * Si no hay logo disponible, renderiza un marcador visual elegante.
 */
const QzTrayPreviewLogo: React.FC<Props> = ({ base64 }) => {
  return (
    <div className="flex justify-center w-full mt-4">
      <div className="w-[280px] sm:w-[300px] rounded-lg border border-stroke dark:border-strokedark bg-white dark:bg-boxdark shadow-sm overflow-hidden">
        {/* 🔹 Encabezado del bloque */}
        <div className="border-b border-stroke dark:border-strokedark bg-gray-100 dark:bg-gray-800 px-3 py-2 text-center">
          <h4 className="text-xs font-semibold text-gray-700 dark:text-gray-200 tracking-wide uppercase">
            Logo del negocio
          </h4>
        </div>

        {/* 🖼️ Contenido del logo */}
        <div className="flex items-center justify-center p-4 bg-gray-50 dark:bg-gray-900 h-28">
          {base64 ? (
            <img
              src={`data:image/png;base64,${base64}`}
              alt="Logo del negocio"
              className="max-h-24 object-contain"
            />
          ) : (
            <span className="text-gray-500 dark:text-gray-400 text-sm italic">
              Sin logo disponible
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default QzTrayPreviewLogo;
